import * as React from 'react'
import type { ReactNode } from 'react'
import clx from 'classnames'
import { faArrowRightFromLineSolid, FaIcon } from '@/lib/fa'
import { Button } from '../../../app/features/common/Button'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'

type Props = {
  onNext?: () => void
  onPrev?: () => void
  className?: string
  isPrev?: boolean
  isNextDisabled?: boolean
  isNext?: boolean
  nextText?: ReactNode
  children?: ReactNode
  nextClassName?: string
  prevClassName?: string
}
export const FooterWithButtons = ({
  onNext,
  onPrev,
  className,
  isPrev = true,
  isNext = true,
  isNextDisabled = false,
  nextText,
  children,
  nextClassName,
  prevClassName,
}: Props) => {
  const { tSafe } = useLocalize()
  const resolvedNextText =
    nextText ?? tSafe('creator.footer.next', 'Następny krok')
  return (
    <div
      className={clx(
        'tw-flex tw-flex-col tw-items-center tw-rounded-t-xl tw-justify-between tw-gap-2 tw-px-4 tw-pt-3 sm:tw-flex-row',
        className,
      )}
    >
      {isPrev && (
        <Button
          onClick={onPrev}
          className={clx(
            'tw-h-10 tw-w-full tw-rounded-lg tw-font-medium sm:tw-w-fit',
            prevClassName,
          )}
        >
          <span>{tSafe('creator.footer.prev', 'Poprzedni krok')}</span>
          <span>
            <FaIcon
              icon={faArrowRightFromLineSolid}
              className="tw-rotate-180"
            />
          </span>
        </Button>
      )}
      {children}
      {isNext && (
        <Button
          disabled={isNextDisabled}
          onClick={onNext}
          className={clx(
            'tw-h-10 tw-w-full tw-rounded-lg tw-font-medium sm:tw-w-fit',
            nextClassName,
          )}
        >
          <span>{resolvedNextText}</span>
          <span>
            <FaIcon
              icon={faArrowRightFromLineSolid}
            />
          </span>
        </Button>
      )}
    </div>
  )
}
